/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Update_ButtonInputs */

const en_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Position`)
};

const fr_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour la position`)
};

const de_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position aktualisieren`)
};

const it_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna posizione`)
};

const ru_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить позицию`)
};

const es_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar posición`)
};

const zh_cn2_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新位置`)
};

const ja_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置を更新`)
};

const hi_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति अद्यतन करें`)
};

const pt_pt2_position_modal_update_button = /** @type {(inputs: Position_Modal_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar posição`)
};

/**
* | output |
* | --- |
* | "Update Position" |
*
* @param {Position_Modal_Update_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_update_button = /** @type {((inputs?: Position_Modal_Update_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Update_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_update_button(inputs)
	if (locale === "de") return de_position_modal_update_button(inputs)
	if (locale === "it") return it_position_modal_update_button(inputs)
	if (locale === "ru") return ru_position_modal_update_button(inputs)
	if (locale === "es") return es_position_modal_update_button(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_update_button(inputs)
	if (locale === "ja") return ja_position_modal_update_button(inputs)
	if (locale === "hi") return hi_position_modal_update_button(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_update_button(inputs)
	return en_position_modal_update_button(inputs)
});